import React from 'react'
import Badge from '../../../common/display/Badge'
import { LPMachineLogicFeaturesSection } from '../../api/Types'
import LandingPageSectionWrapper from '../common/LandingPageSectionWrapper'
import I18n from '../../../../helpers/I18n'

type Props = LPMachineLogicFeaturesSection

interface MachineLogicFeature {
  title: string
  list: MachineLogicFeatureItem[]
  badge_text?: string
}

interface MachineLogicFeatureItem {
  title: string
  badge_text?: string
}

const LandingPageMachineLogicFeature: React.FunctionComponent<{ feature: MachineLogicFeature }> = ({
  feature,
}) => {
  return (
    <div className='machine-logic-features-section-list'>
      <h3 className='machine-logic-features-section-list-title'>
        {feature.title}
        {feature.badge_text && (
          <>
            {' '}
            <Badge color='secondary'>{feature.badge_text}</Badge>
          </>
        )}
      </h3>
      <ul>
        {feature.list.map((item, index) => (
          <li key={index}>
            {item.title}
            {item.badge_text && (
              <>
                {' '}
                <Badge color='success'>{item.badge_text}</Badge>
              </>
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}

const LandingPageMachineLogicFeatures: React.FunctionComponent<Props> = ({ style }) => {
  return (
    <LandingPageSectionWrapper cssNamespace='machine-logic-features-section' style={style}>
      <div className='machine-logic-features-section-grid'>
        <div className='machine-logic-features-section-grid-item'>
          <h2 className='machine-logic-features-section-title'>
            {I18n.t('views.cms.landing_pages.machine_logic_features.title')}
          </h2>
        </div>

        <div className='machine-logic-features-section-grid-item'>
          {I18n.t('views.cms.landing_pages.machine_logic_features.features')
            .slice(0, 3)
            .map((feature: MachineLogicFeature, index) => (
              <LandingPageMachineLogicFeature key={index} feature={feature} />
            ))}
        </div>

        <div className='machine-logic-features-section-grid-item'>
          {I18n.t('views.cms.landing_pages.machine_logic_features.features')
            .slice(3)
            .map((feature: MachineLogicFeature, index) => (
              <LandingPageMachineLogicFeature key={index} feature={feature} />
            ))}
        </div>
      </div>
    </LandingPageSectionWrapper>
  )
}

export default LandingPageMachineLogicFeatures
